import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { heroContent } from '../data/mock';

const Hero = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Hi, I'm interested in Maldives packages from ₹70,000. Can you share details?");
    window.open(`https://wa.me/918591732501?text=${message}`, '_blank');
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center pt-24 overflow-hidden">
      {/* Background Video with Stronger Overlay */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
          poster="https://images.unsplash.com/photo-1698726654908-834d3a5330d8?q=80&w=1920"
        >
          <source src={heroContent.heroVideo} type="video/mp4" />
        </video>
        {/* Stronger overlay (45-50%) for better readability */}
        <div className="absolute inset-0 bg-[#0B1F3A]/47"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 lg:px-8 py-32 text-center">
        <h1 className="heading-xl text-white mb-4 animate-fade-in-up">
          {heroContent.headline}
        </h1>
        <p className="text-lg md:text-xl text-[#C8A96A] mb-6 font-medium animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
          Limited May & June slots available
        </p>
        <p className="text-xl md:text-2xl text-white/95 mb-10 leading-relaxed max-w-3xl mx-auto animate-fade-in-up font-light" style={{ animationDelay: '0.2s' }}>
          {heroContent.subheading}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
          <Button 
            onClick={handleWhatsAppClick}
            size="lg"
            className="bg-[#B8964F] hover:bg-[#a67f3a] text-white text-lg px-12 py-8 rounded-xl shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group font-medium"
          >
            Get Maldives Quote on WhatsApp
            <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform duration-300" size={24} />
          </Button>
        </div>
        <p className="text-sm text-white/80 mt-4 animate-fade-in-up" style={{ animationDelay: '0.5s' }}>
          Response within 10 mins
        </p>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 z-10 animate-fade-in" style={{ animationDelay: '0.6s' }}>
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/60 rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
